export function makeSynonyms(custom, list) {
  list = [...custom, ...list.trim().split("\n")];
  return list;
}

export function companySynonyms() {
  return makeSynonyms(
    ["company", "brand", "business", "draw", "sketch", "logo"],
    `association
club
community
group
team
`
  );
}

export function chatSynonyms() {
  return makeSynonyms(
    ["chatbox", "chat", "boxes"],
    `chatter
conversation
gossip
brick
chunk
piece
section
slab
cake
cube
hunk
ingot
loaf
lump
oblong
segment
slice
`
  );
}

export function bubbleSynonyms() {
  return makeSynonyms(
    ["bubbles", "balloons", "bubble", "balloon"],
    `balloon
blob
droplet
foam
froth
barm
bead
blister
drop
effervescence
lather
sac
spume
vesicle
`
  );
}

export function startSynonyms() {
  return makeSynonyms(
    [],
    `beginning
begin
start
dawn
kickoff
open
outset
countdown
dawn
foundation
incept
init
intro
origin
source
takeoff
alpha
arrival
arrive
come
go
first
jump
set
one
restart
renew
return`
  );
}

export function undoSynonyms() {
  return ["undo", "back", "previous", "prev", "bk", "bak", "sorry", "reverse"];
}

export function secondOptionKeywords() {
  return ["another", "style", "option"];
}
